/**
 * Saisie du code PIN en PASTILLES — forme du prototype v7.3, mais a
 * **6 chiffres** et non 4 (arbitrage Enzo, S32 : « garder le style, 6 au lieu
 * de 4 »).
 *
 * Le 6 n'est pas un detail de style : le backend impose un PIN a 6 chiffres
 * depuis la refonte de la connexion (v0.12.0). Le prototype, reste a 4, est ici
 * en retard sur le portail — on prend sa FORME, pas sa longueur.
 *
 * Mecanique du prototype : un input natif transparent occupe toute la zone et
 * capte le clavier du telephone ; les pastilles ne sont qu'un reflet de la
 * saisie. Avantages sur six champs separes : un seul focus a gerer, le collage
 * d'un code fonctionne, et la suppression ne saute pas de case.
 */
function PinDots({
  value = '', onChange, onComplete, longueur = 6, t,
  id = 'pin', autoFocus = false, disabled = false, aide,
}) {
  const saisir = (brut) => {
    const chiffres = String(brut).replace(/\D/g, '').slice(0, longueur)
    onChange(chiffres)
    if (chiffres.length === longueur && onComplete) {
      // Petit delai : la derniere pastille doit avoir le temps de s'allumer.
      setTimeout(() => onComplete(chiffres), 260)
    }
  }

  return (
    <div>
      <label htmlFor={id} className="block relative cursor-text my-1">
        <span className="sr-only">Code PIN à {longueur} chiffres</span>
        <span className="flex justify-center gap-3">
          {Array.from({ length: longueur }, (_, i) => {
            const rempli = i < value.length
            return (
              <span
                key={i}
                aria-hidden="true"
                className="rounded-full transition-all"
                style={{
                  width: 16, height: 16,
                  background: rempli ? 'rgb(var(--c-primary))' : 'transparent',
                  border: `2px solid ${rempli ? 'rgb(var(--c-primary))' : 'rgba(7,62,61,0.25)'}`,
                }}
              />
            )
          })}
        </span>
        <input
          id={id}
          type="tel"
          inputMode="numeric"
          autoComplete="one-time-code"
          value={value}
          onChange={(e) => saisir(e.target.value)}
          maxLength={longueur}
          autoFocus={autoFocus}
          disabled={disabled}
          className="absolute inset-0 w-full h-full opacity-0"
          style={{ border: 'none', background: 'transparent', fontSize: 16, color: 'transparent', caretColor: 'transparent' }}
        />
      </label>
      <p className={`text-[11.5px] text-center mt-3 ${t.textMuted}`}>
        {aide || `Touchez les points pour saisir votre code à ${longueur} chiffres`}
      </p>
    </div>
  )
}

export default PinDots
